import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Row } from "react-bootstrap";

import "../styles/footer.css";

const Footer = () => {
  const footerbgColor = {
    backgroundColor: "#001538",
    padding: "2rem",
  };

  // const footerTextSize = {
  //   fontSize: "25px",
  // };

  const footerLinkStyle = {
    color: "white",
    paddingLeft: "0.25rem",
  };

  const iconStyle = {
    fontSize: "16px",
    color: "white",
  };

  // const socialIconStyle = {
  //   color: "white",
  //   paddingRight: "1rem",
  // };

  return (
    <div id="contact" style={footerbgColor}>
      <Row>
        {/* Contact Information */}
        <Col md={4}>
          <h4 style={{ color: "white" }}>
            <b>Contact</b>
          </h4>
          <p
            className="card-text"
            style={{
              color: "white",
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <span>Niranjan Dharnaik </span>
            <span>Sarjerao Nagar Ankali - 591213</span>
            <span>GST No-29BFVPD7309Q1ZH</span>
            <span>
              <FontAwesomeIcon icon={faPhone} style={iconStyle} />
              +91-9739236994
            </span>
            <span>
              <FontAwesomeIcon icon={faEnvelope} style={iconStyle} />
              <a
                href="mailto:contact@checs.in"
                style={footerLinkStyle}
              >
                contact@checs.in
              </a>
            </span>
          </p>
        </Col>

        {/* Services */}
        <Col md={4} className="footer-services">
          <h4 style={{ color: "white" }}>
            <b>Services</b>
          </h4>
          <p className="card-text" style={{ color: "white" }}>
            CAE/FEA <br />
            CAD <br />
            Technical staffing solutions <br />
            Handling In-House Projects
          </p>
        </Col>

        {/* Other Contacts */}
        <Col md={4} className="footer-other">
          <h4 style={{ color: "white" }}>
            <b>CAE/FEA Training Contact</b>
          </h4>
          <p
            className="card-text"
            style={{
              color: "white",
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <span>Rahul Dharnaik</span>
            <span>
              <FontAwesomeIcon icon={faPhone} style={iconStyle} />
              +91-8867613952
            </span>
          </p>
          <h4 style={{ color: "white" }}>
            <b>CAD Training Contact</b>
          </h4>
          <p
            className="card-text"
            style={{
              color: "white",
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <span>Jode Deviprasad</span>
            <span>
              <FontAwesomeIcon icon={faPhone} style={iconStyle} />
              +91-9767040422
            </span>
          </p>
        </Col>
      </Row>
      <Row>
        <div className="footer-copyright" style={{ color: "white", paddingRight: "2rem", marginTop: "1rem" }}>
          <span>&copy; Chetan Engineering & Consultancy Services</span>
          <span>
            <a
              style={{ color: "#e2e2e2" }}
              target="_blank"
              href="http://www.makeanybot.com"
              rel="noreferrer"
            >
              SMK Solutions
            </a>
          </span>
        </div>
      </Row>

      {/* <Row style={{ paddingTop: "1rem" }}>
        <Col lg={12}>
          <p style={{ color: "white", paddingRight: "2rem" }}>
            &copy; Chetan Engineering & Consultancy Services
            <span style={{ float: "right" }}>
              <a
                style={{ color: "#e2e2e2" }}
                target="_blank"
                href="http://www.makeanybot.com"
                rel="noreferrer"
              >
                SMK Solutions
              </a>
            </span>
          </p>
        </Col>
      </Row> */}
    </div>
  );
};

export default Footer;
